<template>
  <fix-centerv1 class="qr_code_pop" v-dialogDrag v-model="visible" w="790" h="600" @close="onClose">
    <span slot="title">码上服务</span>
    <template slot="main">
      <el-tabs v-model="curTab" class="code_serve">
        <el-tab-pane name="trace">
          <div slot="label" class="tab_title">溯源码</div>
          <div :class="{'tab_content': true, 'expired': order.traceExpired}">
            <div class="part">
              <div class="top_bar">
                <p class="bar_title">订单-汇总-溯源码</p>
                <div class="f_bt red" @click="downloadTrace">{{order.traceExpired ? '“溯源码”已过期' : '下载“溯源码”'}}</div>
                <!-- <div class="f_bt" @click="resetTraceCode">重置</div> -->
              </div>
              <div class="part_main">
                <div class="code_box">
                  <img :src="order.traceExpired ? expiredIcon : flowImgUrl" alt="汇总溯源码">
                  <p class="code_name">汇总溯源码</p>
                </div>
              </div>
            </div>
            <div class="part">
              <div class="top_bar">
                <p class="bar_title">订单-分城市-溯源码</p>
                <div class="f_bt purple" :class="{'disable': cityTip}" @click="downloadAllTrace">
                  {{order.traceExpired ? '“溯源码”已过期' : '一键下载所有'}}
                </div>
              </div>
              <div class="part_main">
                <div class="scroll_list">
                  <div v-if="!order.traceExpired && cityTip" class="tip_text">{{ cityTip }}</div>
                  <div class="qr_city" v-for="(ct, j) in cityArr" :key="ct.cityCode">
                    <div class="city_name" :title="ct.cityName.length > 17 ? `${j+1}.${ct.cityName}_溯源码` : ''">{{ j + 1 }}.{{ ct.cityName }}_溯源码</div>
                    <div class="download_city" @click="downloadCityTraceCode(ct)">下载</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="monit">
          <div slot="label" class="tab_title">监播码</div>
          <div :class="{'tab_content': true, 'expired': order.noMonit || monitDisable}">
            <div class="part">
              <div class="top_bar">
                <p class="bar_title">订单-汇总-监播码</p>
                <div class="f_bt green" :class="{'disable': monitDisable}" @click="downloadMonit">{{monitDisable ? '该订单暂不支持' : order.noMonit ? '“监播码”已过期' : '下载“监播码”'}}</div>
                <!-- <div class="f_bt" @click="resetMonitCode">重置</div> -->
              </div>
              <div class="part_main">
                <div class="code_box">
                  <img :src="(order.noMonit || monitDisable) ? expiredIcon : monitImgUrl" alt="汇总监播码">
                  <p class="code_name">汇总监播码</p>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="faq">
          <div slot="label" class="tab_title">常见问题</div>
          <div class="tab_content">
            <div class="faq_box">
              <ul class="question">
                <li>
                  <div class="stress">如何进行在线监播/溯源？</div>
                  <p>1. 获取“监播码/溯源码”；</p>
                  <p>2. 打开微信“扫一扫”，或者搜索打开小程序【梯之星溯源】，点击“立即扫码”即可进行在线监播/溯源。</p>
                </li>
                <li>
                  <div class="stress">监播码/溯源码 有效期多久？</div>
                  <p>1. 监播码的有效期为订单上刊日期+60天。</p>
                  <p>2. 溯源码的有效期以订单下单时的数据存储时间为准，且不可更改。</p>
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template slot="btm">
      <div class="fix-btn" @click="onClose">关闭</div>
    </template>
  </fix-centerv1>
</template>

<script>
import JSZip from 'jszip'
import FileSaver from 'file-saver'
// import { orderPage } from "@/utils/api"
import BaseData from '@/utils/baseData'
import expiredIcon from '@/assets/qrcode_expired.png'

export default {
  name: 'MonitPopper',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      expiredIcon,
      curTab: 'trace',
      monitImgUrl: '',
      flowImgUrl: '',
      cityArr: [],
      cityTip: null
    }
  },
  computed: {
    visible: {
      get () {
        return this.show
      },
      set (v) {
        this.$emit('update:show', v)
      }
    },
    // 禁用监播码
    monitDisable() {
      // RTB(限量)广告
      const isRTB = (this.order && this.order.orderType === 6010)
      // 特殊用户(18967830077) 不支持监播码
      // const limitUser = [2000409].indexOf(this.adUser.id) > -1
      // return isRTB || limitUser
      return isRTB
    }
  },
  async created() {
    if (!this.order.traceExpired) this.generateTraceCode()
    if (!this.order.noMonit) this.generateMonitCode()

    const res = await this.fetch(`/orderlite/api/v3/inner/order/${this.order.orderGuid}/cityCodes`, {}, 'get')
    if (res && res.code === 0 && res.data) {
      let tmp = []
      for (let j = 0; j < res.data.length; j++) {
        const cityCode = res.data[j]
        const cityName = await BaseData.getName(cityCode)
        tmp.push({ cityCode, cityName })
      }
      this.cityArr = tmp
    } else if (res.code === 900501) {
      this.cityTip = '订单未过审，溯源城市码尚未生成'
    }

    // const res = await orderPage({
    //   codeBlur: this.order.orderCode,
    //   fields: 'placedSchedule',
    //   pageNum: 1,
    //   pageSize: 20
    // })
    // if (res && res.code === 0 && res.data) {
    //   const cur = res.data.list[0] || {}
    //   if (cur.id && cur.placedSchedule) {
    //     let tmp = []
    //     for (let j = 0; j < cur.placedSchedule.cityCascadeCodes.length; j++) {
    //       const { cityCode } = cur.placedSchedule.cityCascadeCodes[j]
    //       const cityName = await BaseData.getName(cityCode)
    //       tmp.push({ cityCode, cityName })
    //     }
    //     this.cityArr = tmp
    //   }
    // }
  },
  methods: {
    async generateTraceCode(isReset) {
      const blob = await this.fetch(`/traceability/web/trace/getQRCode?orderId=${this.order.guid}&type=${isReset?"1":"0"}`, "", "blob-get")
      this.flowImgBlob = blob || null
      this.flowImgUrl = this.flowImgBlob ? URL.createObjectURL(this.flowImgBlob) : ""
    },
    async generateMonitCode(reset) {
      const blob = await this.fetch(`/traceability/web/trace/getDetectQRCode?orderId=${this.order.guid}&type=${reset?'1':'0'}`, "", "blob-get")
      this.monitImgBlob = blob || null
      this.monitImgUrl = this.monitImgBlob ? URL.createObjectURL(this.monitImgBlob) : ""
    },
    downloadTrace() {
      if (this.flowImgBlob) {
        this.$blobSaveFile(this.flowImgBlob, `订单${this.order ? this.order.orderCode : ""}溯源码.png`)
      }
    },
    // resetTraceCode() {
    //   this.generateTraceCode(true)
    // },
    async downloadAllTrace() {
      if (this.order.traceExpired || !this.cityArr.length) return
      const zip = new JSZip()
      const load = this.$loading()
      for (const city of this.cityArr) {
        const { cityCode, cityName } = city
        const blob =  await this.fetch(`/traceability/web/trace/getQRCode?orderId=${this.order.guid}&type=0&cityCodes=${cityCode}`, '', 'blob-get')
        if (blob) {
          const name = `订单${this.order.orderCode}-${cityName}-溯源码.png`
          zip.file(name, blob, { binary: true })
        } else {
          console.warn(`订单的${cityName}溯源码下载失败`)
        }
      }
      const content = await zip.generateAsync({ type: 'blob' })
      load.close()
      FileSaver.saveAs(content, `订单${this.order.orderCode}分城市溯源码`)
    },
    async downloadCityTraceCode(dist) {
      if (this.order.traceExpired) return
      const { cityCode, cityName } = dist
      const api = `/traceability/web/trace/getQRCode?orderId=${this.order.guid}&type=0&cityCodes=${cityCode}`
      const blob = await this.fetch(api, '', 'blob-get')
      if (blob) {
        const name = `订单${this.order.orderCode}-${cityName}-溯源码.png`
        const url = URL.createObjectURL(blob)
        if ('download' in document.createElement('a')) { // 非IE下载
          const a = document.createElement('a')
          a.style.display = 'none'
          document.body.appendChild(a)
          a.href =  url
          a.target = '_blank'
          a.download = name
          a.click()
          document.body.removeChild(a)
        } else {
          console.warn('浏览器不支持a标签下载')
          this.messageTip('您的浏览器暂不支持，建议更换谷歌浏览器', 2)
        }
      }
    },
    downloadMonit() {
      if (this.monitDisable || this.order.noMonit) return
      if (this.monitImgBlob) {
        this.$blobSaveFile(this.monitImgBlob, `订单${this.order ? this.order.orderCode : ""}监播码.png`)
      }
    },
    // resetMonitCode() {
    //   this.generateMonitCode(true)
    // },
    onClose() {
      if (this.monitImgUrl) URL.revokeObjectURL(this.monitImgUrl)
      if (this.flowImgUrl) URL.revokeObjectURL(this.flowImgUrl)
      this.monitImgUrl = ''
      this.flowImgUrl = ''
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.qr_code_pop {
  ::v-deep .fix-box .fix-center-main {
    padding: 0;
  }
}
.code_serve {
  height: 100%;
  .tab_content {
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-shadow: 0 0 0 1px #E9E9E9;
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    &.expired {
      .top_bar .f_bt {
        cursor: not-allowed;
        background: #D4D4D4;
      }
      .part_main {
        .download_city {
          cursor: not-allowed;
          color: #B8B8B8;
          text-decoration: none;
        }
      }
    }
    .f_bt {
      cursor: pointer;
      width: 113px;
      height: 30px;
      line-height: 30px;
      border-radius: 4px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      &.green {
        background: linear-gradient(360deg, #58CDA6 0%, #44A08D 100%);
      }
      &.red {
        background: linear-gradient(315deg, #FF846D 0%, #FF3973 100%);
      }
      &.purple {
        background: #6629E7;
      }
      &.disable {
        cursor: not-allowed;
        background-color: #D4D4D4;
      }
    }
    .part {
      flex: 1 0;
      height: 100%;
      & + .part {
        box-shadow: -1px 0 0 0 #E9E9E9;
      }
      .top_bar {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0 1px 0 0 #E9E9E9;
        padding: 0 20px;
        .bar_title {
          font-weight: bold;
        }
      }
    }
    .part_main {
      height: calc(100% - 50px);
      .code_box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img {
          width: 180px;
          height: 180px;
        }
        .code_name {
          color: #999;
          margin-top: 10px;
        }
      }
      .scroll_list {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden auto;
        padding: 20px 15px 20px 20px;
        .tip_text {
          color: #999;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          white-space: nowrap;
        }
        .qr_city {
          width: 100%;
          height: 38px;
          background: #F5F5F5;
          border-radius: 4px;
          box-shadow: 0 0 0 1px #D4D4D4;
          padding: 0 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
          .city_name {
            max-width: 280px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .download_city {
        cursor: pointer;
        color: #6629E7;
        flex-shrink: 0;
        text-decoration: underline;
      }
    }
    .faq_box {
      padding: 40px;
      .question {
        padding-left: 16px;
        li {
          list-style: disc;
          &:not(:last-child) {
            margin-bottom: 30px;
          }
        }
        .stress {
          font-weight: bold;
          line-height: 16px;
          margin-bottom: 10px;
        }
        p {
          font-size: 13px;
          & + p {
            margin-top: 5px;
          }
        }
      }
    }
  }
  ::v-deep .el-tabs__header {
    background-color: #fff;
    margin-bottom: 0;
    .el-tabs__nav-wrap {
      &::after {
        height: 1px;
        background-color: #E9E9E9;
      }
      .el-tabs__nav {
        text-align: center;
        width: 100%;
        .el-tabs__active-bar {
          display: none;
        }
        .el-tabs__item {
          color: #999999;
          display: inline-block;
          padding: 0;
          width: 33.3%;
          box-sizing: content-box;
          .tab_title {
            font-weight: bold;
          }
          &:not(:last-child) {
            &:after {
              background: #E9E9E9;
              content: '';
              width: 1px;
              height: 20px;
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          &.is-active {
            color: #282729;
            .tab_title {
              display: inline-block;
              border-bottom: 1px solid #282729;
              height: 100%;
            }
          }
        }
      }
    }
  }
  ::v-deep .el-tabs__content {
    height: calc(100% - 40px);
    .el-tab-pane {
      background-color: #F5F5F5;
      height: 100%;
      padding: 20px;
    }
  }
}
</style>
